import script from "./NotificationItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationItems.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationItems.vue?vue&type=style&index=0&id=4869f49e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4869f49e"]])

export default __exports__